let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cl6aX")).then(() => parcelRequire('bTxKJ'));